import { useState, useEffect } from 'react';
import { frandroidAPI, Operator } from '../services/frandroid-api';
import { PLAN_TYPES, type PlanType } from '../config/api';

export function useOperators(planType: PlanType = PLAN_TYPES.MOBILE) {
  const [operators, setOperators] = useState<Operator[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    let cancelled = false;

    async function fetchData() {
      try {
        const data = await frandroidAPI.getOperators(planType);
        if (cancelled) return;
        setOperators(data);
      } catch (err) {
        if (cancelled) return;
        setError(err instanceof Error ? err : new Error('Unknown error'));
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    fetchData();

    return () => {
      cancelled = true;
    };
  }, [planType]);

  return { operators, loading, error };
}
